import React from 'react';
import image1 from '../../assets/aboutUs_heading/image1.png';
import mandala from '../../assets/wallpaper.png';
import ScrollToHashElement from '../ScrollToHashElement'; // 👈 Import here

const Heading = () => {
  return (
    <div id="about" className="w-full bg-white -mt-2 px-6 md:px-20 pt-10 relative overflow-hidden">
      <ScrollToHashElement/>{/* Mandala backgrounds - hidden on small screens */}
      <img
        src={mandala}
        alt="Mandala top right"
        className="hidden md:block absolute bottom-[-400px] right-[-210px] w-[500px] opacity-[0.7] z-0"
      />
      <img
        src={mandala}
        alt="Mandala top right"
        className="hidden md:block absolute bottom-[-400px] left-[-210px] w-[500px] opacity-[0.7] z-0"
      />

      <div className="flex flex-col md:grid md:grid-cols-[1.5fr_1fr] gap-4 z-10">
        {/* Text content container */}
        <div className="flex flex-col">
          {/* Headings (appear before image on mobile) */}
          <div>
            <h2 className="text-[14px] md:text-[22px] tracking-[0.16em] md:tracking-[0.3em] font-semibold text-[#404040] md:text-gray-700 mb-4">
              ABOUT US
            </h2>
            <h1 className="text-[28px] md:text-[36px] font-bold text-[#AD2F3B] max-w-4xl leading-snug mb-6 md:mb-10">
              Enabling patrons achieve business and social goals through curated Indian traditional performing arts
            </h1>
          </div>

          {/* Image (appears after headings but before paragraphs on mobile) */}
          <div className="md:hidden flex justify-center my-6">
            <div className="w-[330px] h-[330px] rounded-full overflow-hidden shadow-[15px_0_5px_10px_#FBF1F3]">
              <img
                src={image1}
                alt="ghungroo"
                className="object-cover w-full h-full"
              />
            </div>
          </div>

          {/* Paragraph content (appears after image on mobile) */}
          <div className="text-[#404040] text-[16px] md:text-[20px] leading-[24px] md:leading-[32px] max-w-4xl font-medium">
            <p className="mb-4 md:mb-6">
              eKalakaar is a pioneering digital platform that helps patrons achieve business and social goals through curated Indian traditional performing arts.
            </p>
            <p className="mb-4 md:mb-6">
              We serve as a <strong>cultural communication</strong> partner for corporates, governments, the social sector, and hospitality leaders by delivering bespoke, thematic performances for events, conferences, and campaigns.
            </p>
            <p className="mb-4">
              Our mission goes beyond entertainment — we aim to preserve India's rich cultural heritage while supporting traditional artists with
            <span className="mb-4  font-bold"> Naam(visibility), Kaam(opportunity), and Daam(fair compension).</span></p>

            <a
              href="#about"
              className="text-[#AD2F3B] underline text-[16px] md:text-[18px] inline-flex items-center gap-2 mt-1"
            >
              {/* 🔗 Learn more about us */}
            </a>
          </div>
        </div>

        {/* Image for desktop (hidden on mobile) */}
        <div className="hidden md:flex items-center justify-start h-full ml-[130px] z-10">
          <div className="relative -left-[46px] w-[550px] h-[550px] rounded-full overflow-hidden shadow-[30px_0_5px_20px_#FBF1F3]">
            <img
              src={image1}
              alt="ghungroo"
              className="object-cover w-full h-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Heading;